import { FC } from "react";
import { BrokerOnboardingRequestDto } from "../../../api/Api";
import { OnboardingRequestsAdminGrid } from "../../../components/onboardingRequests/adminRequestsGrid";
import { OnboardingRequestBook } from "../../../components/onboardingRequests/types";
import { useBrokerOnboardingRequests } from "./queries";
import { ReviewDialog } from "./reviewDialog";

const brokerBook: OnboardingRequestBook<BrokerOnboardingRequestDto> = {
  entityLabel: "Broker",
  entityName: (row) => row.payload?.brokerName ?? "",
  resultingEntityId: (row) => row.resultingBrokerId,
  entityPath: (id) => `/brokers/broker/${id}`
};

export const BrokerOnboardingRequestsAdmin: FC = () => (
  <OnboardingRequestsAdminGrid
    book={brokerBook}
    useRequests={useBrokerOnboardingRequests}
    renderReviewDialog={({ open, request, onClose }) => (
      <ReviewDialog open={open} request={request} onClose={onClose} />
    )}
  />
);
